import { render, staticRenderFns } from "./mineView.vue?vue&type=template&id=65587168&"
import script from "./mineView.vue?vue&type=script&lang=js&"
export * from "./mineView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports